// extracted by css-extract-rspack-plugin
export default {"avatar":"SnJG7"};